import firebase from 'firebase/app';
import { firebaseConfig } from "./firebase.config";
import * as database from "firebase/database";

firebase.initializeApp(firebaseConfig);

export default firebase.database();
